/* One Way Slab */
export const SLAB_TYPE = {
  SIMPLY_SUPPORTED: 1,
  CANTILEVER: 2,
} as const

export type SlabType = keyof typeof SLAB_TYPE

/* One Way Slab */
export interface OneWaySlabInput {
  slabType: SlabType
  beamSpan: number
}

/* Two Way Slab */
export interface TwoWaySlabInput {
  longSideSpan: number
  shortSideSpan: number
}

/* Beam */
export interface BeamInput {
  rebarStrength: number
  beamSpan: number
}

/* Column */
export const USAGE = {
  RESIDENTIAL: 3,
  PATIENT_ROOM: 2,
  OPERATING_ROOM: 5,
  HOTEL: 2,
  OFFICE: 2.5,
  CLASSROOM: 3,
  LABORATORY: 5,
  STORE: 5,
  WHOLESALE: 6,
  THEATER: 5,
  BALLROOM: 5,
  GYMNASIUM: 5,
  READING_ROOM: 3,
  STACK_ROOM: 7.5,
  LIGHT_STORAGE_WAREHOUSE: 6,
  HEAVY_STORAGE_WAREHOUSE: 12,
  LIGHT_INDUSTRIAL_PLANT: 6,
  HEAVY_INDUSTRIAL_PLANT: 12,
} as const

export type UsageKey = keyof typeof USAGE

export interface ColumnInput {
  longSideSpan: number
  shortSideSpan: number
  usage: UsageKey
  slabThickness: number
  stories: number
  concreteStrength: number
  criterionSize: number
}

export interface FoundationInput extends ColumnInput {
  floorHeight: number
  bearingCapacity: number
}

export interface BasementWallInput {
  b1Height: number
  b2Height: number
  b3Height: number
  b4Height: number
  b5Height: number
  whetherCalc: number[]
}

export interface WindTunnelStudyInput {
  outerArea: number
  height: number
}
